<template>
  <div class="p20">
    <titleBar title="我的流程"></titleBar>
    <div class="mt10">
      <van-grid :column-num="2">
        <van-grid-item v-for="(item,i) in flowsTemplateList" :key="i" @click="change(item)">
          <div class="avatar">{{ item.templateName.substring(0, 1) }}</div>
          <div class="first-title m-t-20">{{ item.templateName }}</div>
          <div class="second-title m-t-20">{{ item.remark }}</div>
        </van-grid-item>
      </van-grid>
    </div>


  </div>
</template>

<script>
import {getUseFlows} from "@/api/flow";
import titleBar from "@/components/title-bar.vue";

export default {
  data() {
    return {
      // 后台返回的和用户关联的flow列表
      userFlows: [],
      // 通一种流程类型下的多个流程模版
      flowsTemplateList: [],
      // 匹配到的路由
      route: {}
    }
  },
  components: {
    titleBar
  },
  created() {
    // 需要从企微配置的url中获取流程groupId
    const groupId = this.$route.query.groupId;
    const WeChatEnterprise = this.$route.query.WeChatEnterprise;

    // 增加路由查找的健壮性
    this.findRouteByGroupId(groupId);

    getUseFlows().then(res => {
      this.userFlows = res.data
      this.flowsTemplateList = res.data.filter(item => item.groupId == groupId)
      // 只有一项时 直接跳转
      if (this.flowsTemplateList.length === 1) {
        this.autoRedirectSingleFlow(groupId);
      } else if (this.$route.query.reSend) {
        this.autoRedirectResendFlow(groupId);
      }
    }).catch(error => {
      console.error('获取流程列表失败:', error);
      // 可以在这里添加错误提示
    })
  },
  methods: {
    // 查找路由方法
    findRouteByGroupId(groupId) {
      if (!groupId) {
        console.error('groupId为空，无法查找路由');
        return;
      }

      // 将groupId转换为数字进行比较，避免类型问题
      const numGroupId = Number(groupId);
      this.route = this.$router.options.routes.find(item => {
        if (item?.meta?.groupId) {
          // 统一转换为数字进行比较
          const routeGroupId = Number(item.meta.groupId);
          return routeGroupId === numGroupId;
        }
        return false;
      });

      if (!this.route) {
        console.error(`未找到groupId为${groupId}对应的路由`);
      }
    },

    // 自动跳转单个流程
    autoRedirectSingleFlow(groupId) {
      if (!this.route) {
        console.error('路由未找到，无法自动跳转');
        return;
      }

      const templateId = this.flowsTemplateList[0].templateId;
      let query = {
        templateId,
        groupId: groupId
      }
      if (this.$route.query.reSend) {
        query = {
          ...query,
          reSend: this.$route.query.reSend,
          processInstanceId: this.$route.query.processInstanceId
        }
      }
      this.$router.push({
        path: this.route.path,
        query
      });
    },

    // 自动跳转重新发送的流程
    autoRedirectResendFlow(groupId) {
      if (!this.route) {
        console.error('路由未找到，无法自动跳转');
        return;
      }

      // 比对templateId 找到对应的路由
      const templateId = this.$route.query.templateId;
      const route = this.flowsTemplateList.find(item => {
        // 统一类型比较
        return item.templateId == templateId;
      });

      if (!route) {
        console.error(`未找到templateId为${templateId}对应的流程`);
        return;
      }

      let query = {
        templateId: route.templateId,
        groupId: groupId,
        reSend: this.$route.query.reSend,
        processInstanceId: this.$route.query.processInstanceId
      }
      this.$router.push({
        path: this.route.path,
        query
      });
    },

    change(item) {
      if (!this.route) {
        console.error('路由未找到，无法跳转');
        return;
      }

      const templateId = item.templateId
      const groupId = item.groupId
      this.$router.push({
        path: this.route.path,
        query: {
          templateId,
          groupId
        }
      })
    }
  }
}

</script>

<style scoped lang="less">
.avatar {
  width: 100px;
  height: 100px;
  line-height: 100px;
  border-radius: 50%;
  background: @theme-color;
  text-align: center;
  font-size: 44px;
}
</style>
